var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPossibleLogoInverted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 24,
    viewBox: "0 0 127 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23019_21666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5394 0.197937H0.761719V11.9631H12.5394V0.197937Z",
    fill: "#0577FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5394 11.9631H0.761719V23.7282H12.5394V11.9631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9031 0.170593H25.741C30.2175 0.170593 33.1802 2.86302 33.1802 6.96961C33.1802 11.0762 30.2183 13.7679 25.7417 13.7679H19.967V23.7312H16.9031V0.170593ZM25.4382 11.1094C28.2658 11.1094 30.1164 9.4597 30.1164 6.96961C30.1164 4.47952 28.2658 2.82906 25.4382 2.82906H19.9662V11.1094H25.4382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7126 15.2492C32.7126 10.1332 36.3141 6.49847 41.295 6.49847C46.276 6.49847 49.8782 10.1332 49.8782 15.2492C49.8782 20.3653 46.2427 24 41.295 24C36.3141 24 32.7126 20.3653 32.7126 15.2492ZM41.295 21.476C44.5938 21.476 46.9494 18.9179 46.9494 15.2492C46.9494 11.5466 44.5938 8.98857 41.295 8.98857C37.9963 8.98857 35.6406 11.5466 35.6406 15.2492C35.6406 18.9179 37.9971 21.476 41.295 21.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0894 18.1773H53.9841C54.2197 20.3313 55.6331 21.5432 57.8241 21.5432C59.911 21.5432 61.221 20.6341 61.221 18.8847C61.221 14.7117 51.528 17.3339 51.528 11.0762C51.528 8.48494 53.8837 6.49774 57.2828 6.49774C60.9854 6.49774 63.3382 8.3151 63.813 11.5798H60.9182C60.6827 9.86291 59.2013 8.9546 57.2828 8.9546C55.6338 8.9546 54.3548 9.62734 54.3548 10.9736C54.3548 14.8136 64.1158 11.9838 64.1158 18.816C64.1158 21.8792 61.4906 23.9993 57.8219 23.9993C53.4458 24 51.2577 21.106 51.0894 18.1773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4177 18.1773H68.3125C68.5481 20.3313 69.9615 21.5432 72.1525 21.5432C74.2394 21.5432 75.5494 20.6341 75.5494 18.8847C75.5494 14.7117 65.8564 17.3339 65.8564 11.0762C65.8564 8.48494 68.2121 6.49774 71.6119 6.49774C75.3139 6.49774 77.6673 8.3151 78.1414 11.5798H75.2467C75.0111 9.86291 73.5305 8.9546 71.6119 8.9546C69.9622 8.9546 68.6832 9.62734 68.6832 10.9736C68.6832 14.8136 78.4442 11.9838 78.4442 18.816C78.4442 21.8792 75.819 23.9993 72.1503 23.9993C67.7742 24 65.5861 21.106 65.4177 18.1773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5679 6.76727H83.4626V23.7312H80.5679V6.76727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1216 20.9376V23.7312H86.2268V0.0450439H89.1216V9.52616C90.0978 7.67483 92.4535 6.49846 94.9783 6.49846C100.06 6.49846 103.426 9.99877 103.426 15.2492C103.426 20.4997 100.06 24 94.9783 24C92.4875 24 90.0978 22.7882 89.1216 20.9376ZM94.8077 21.5099C98.0725 21.5099 100.494 18.9519 100.494 15.2492C100.494 11.5466 98.0703 8.98855 94.8077 8.98855C91.4758 8.98855 89.1216 11.5466 89.1216 15.2492C89.1216 18.9179 91.478 21.5099 94.8099 21.5099H94.8077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.301 0.0184326H108.196V23.7312H105.301V0.0184326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.071 15.2492C110.071 10.1332 113.571 6.49847 118.385 6.49847C123.568 6.49847 126.803 10.5371 126.16 15.6192H112.999C113.134 19.2207 115.288 21.5099 118.486 21.5099C120.943 21.5099 122.558 20.2641 123.097 18.3124H125.992C125.385 21.6103 122.491 23.9985 118.586 23.9985C113.571 24 110.071 20.3653 110.071 15.2492ZM123.231 13.3292C123.231 10.6368 121.245 8.95386 118.385 8.95386C115.625 8.95386 113.74 10.5046 113.167 13.3292H123.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.982 0C83.1259 0 83.9678 0.807877 83.9678 1.92C83.9678 3.03212 83.1259 3.84 81.982 3.84C80.8743 3.84 80.0295 3.03212 80.0295 1.92C80.0295 0.807877 80.8714 0 81.982 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23019_21666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125.478,
    height: 24,
    fill: "white",
    transform: "translate(0.761719)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPossibleLogoInverted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PossibleLogoInverted.23d4c62deef14c7fa070f066b27cf71f.svg";